<div class="row mt-4 mb-4">
  <div class="col">
    <h3>{{ 'trade.multi-order.create.buy.headline' | transloco }}</h3>
    @if ((facade.loadingMultiOrderInstruments$ | async) === false) {
      @if (facade.multiOrderBuyList$ | async; as buyList) {
        @if (buyList.length) {
          <div class="row mt-3 table-header">
            <div class="col-1">{{ 'trade.multi-order.create.buy.qty' | transloco }}</div>
            <div class="col-9 col-sm-5 pl-5 pl-sm-4">{{ 'trade.multi-order.create.buy.name' | transloco }}</div>
            <div class="col-2 d-none d-sm-block">{{ 'trade.multi-order.create.buy.quote' | transloco }}</div>
            <div class="col-2 d-none d-sm-block" [innerHTML]="'trade.multi-order.create.buy.estimated-sum' | transloco"></div>
            <div class="col-2"></div>
          </div>
          <hr class="thin" />
          @for (i of buyList; track i.isin) {
            <ng-template #quote>
              @if (!i.quote) {
                &mdash;
              } @else {
                {{ i.quote?.ask | currency }}
              }
            </ng-template>
            <ng-template #estimatedSum>
              @if (!i.estimatedSum || i.error) {
                &mdash;
              } @else {
                {{ i.estimatedSum + (i.minimumSurcharge ?? 0) | currency }}
              }
            </ng-template>
            <div class="row align-items-center">
              <div class="col-1">
                <div class="input-group-material keepcolor" [class.input-group-material--error]="i.error">
                  <input
                    type="number"
                    class="form-control"
                    [ngModel]="i.qty"
                    (ngModelChange)="facade.updateQuantity(i, $event)"
                    (wheel)="handleWheel($event)"
                  />
                </div>
              </div>
              <div class="col-9 col-sm-5 pl-5 pl-sm-4 text-break">
                {{ i.asset?.longName }}
                @if (i.error) {
                  <div class="text-color-error text-size-small">{{ i.error | transloco }}</div>
                }
              </div>
              <div class="col-2 d-none d-sm-block">
                <ng-container *ngTemplateOutlet="quote" />
              </div>
              <div class="col-2 d-none d-sm-block">
                <ng-container *ngTemplateOutlet="estimatedSum" />
              </div>
              <div class="col-2 text-right deletion-col">
                <svg class="icon icon-18 cursor-pointer" (click)="facade.removeMultiOrderInstrument(i)">
                  <use xlink:href="/assets/img/svgs/svgset.svg#cross-black" />
                </svg>
              </div>
            </div>
            <trade-multi-order-notice [notice]="i.notice" (proceed)="facade.confirmMultiOrderNotice(i)" />
            <div class="row align-items-center d-flex d-sm-none mt-2">
              <div class="col text-nowrap thead-mobile">{{ 'trade.multi-order.create.buy.quote' | transloco }}</div>
              <div class="col text-nowrap text-right tbody-mobile">
                <ng-container *ngTemplateOutlet="quote" />
              </div>
            </div>
            <div class="row align-items-center d-flex d-sm-none mt-2">
              <div class="col text-nowrap thead-mobile">
                {{ 'trade.multi-order.create.buy.sum' | transloco }}
              </div>
              <div class="col text-nowrap text-right tbody-mobile">
                <ng-container *ngTemplateOutlet="estimatedSum" />
              </div>
            </div>
            <hr class="thin" />
          }
        }
      }
      <div class="mt-3 link-secondary cursor-pointer no-select text-decoration-none" (click)="addToBuyList()">
        <svg class="icon icon-18">
          <use xlink:href="/assets/img/svgs/svgset.svg#add-instrument" />
        </svg>
        @if (facade.multiOrderBuyList$ | async; as buyList) {
          @if (buyList.length) {
            {{ 'trade.multi-order.create.buy.add-further' | transloco }}
          } @else {
            {{ 'trade.multi-order.create.buy.add-first' | transloco }}
          }
        }
      </div>
      @if (facade.multiOrderBuyList$ | async; as buyList) {
        @if (buyList.length) {
          <hr />
          <trade-multi-order-estimated-sum direction="buy" />
        }
      }
    }
  </div>
</div>
